import { useSelector } from 'react-redux';

const useIsPanelOpenPreference = () =>
  useSelector((state) => state.searchPreferences.refinement_panel_state);

export default useIsPanelOpenPreference;
